define('container/initialisers/ConstructorInitialiser',['underscore'], function(_) {

    'use strict';

    /**
     * Initialise the module with any args using "new".
     */
    function ConstructorInitialiser() {
    }

    ConstructorInitialiser.prototype.canInitialise = function(extensionApi) {
        return extensionApi.serviceDefinition.init === 'constructor';
    };

    ConstructorInitialiser.prototype.initialise = function(instanceCreatedCallback, loadedModule) {

        var instance = new (Function.bind.apply(
            loadedModule,
            Array.prototype.slice.call(arguments, 1)
        ))();

        instanceCreatedCallback(instance);

        return instance;
    };

    return ConstructorInitialiser;

});

